import React, { useState } from 'react';
import './App.css';
import { LensProvider } from './components/LensProvider';
import { NarrativeProvider, useNarrative } from './narrative/NarrativeProvider';
import { Controls } from './components/Controls';
import { ExperiencePanel } from './components/ExperiencePanel';
import { Visualization } from './components/Visualization';
import { EventAffordancePanel } from './components/EventAffordancePanel';
import TemporalRibbon from './components/TemporalRibbon';
import ExperienceMeter from './components/ExperienceMeter';
import Walkthrough from './components/Walkthrough';
import DisclaimerPanel from './components/DisclaimerPanel';
import LandingIntro from './components/LandingIntro';
import Presets from './components/Presets';
import HowItWorks from './components/HowItWorks';
import ApertureMirror from './components/ApertureMirror';

function AppContent() {
  const { activeDisclaimer, setActiveDisclaimer } = useNarrative();
  const [mirrorComplete, setMirrorComplete] = useState(
    sessionStorage.getItem('mirrorComplete') === 'true'
  );

  const handleMirrorComplete = () => {
    setMirrorComplete(true);
    sessionStorage.setItem('mirrorComplete', 'true');
    // Also dismiss landing intro since mirror already oriented the user
    sessionStorage.setItem('introDismissed', 'true');
  };

  // Show mirror first for new visitors (unless they came via URL params)
  const hasUrlParams = window.location.search.includes('B=');
  const showMirror = !mirrorComplete && !hasUrlParams;

  return (
    <div className="App">
      {showMirror && <ApertureMirror onComplete={handleMirrorComplete} />}
      {!showMirror && <LandingIntro />}
      <Walkthrough />
      <DisclaimerPanel disclaimer={activeDisclaimer} onClose={() => setActiveDisclaimer(null)} />
      <header className="App-header">
        <h1>Pressure Gradients</h1>
        <p className="App-subtitle">An aperture model of human experience</p>
        <HowItWorks />
      </header>
      <main>
        <div className="controls-container">
          <Presets />
          <Controls />
        </div>
        <div className="output-container">
          <Visualization />
          <ExperiencePanel />
          <EventAffordancePanel />
          <TemporalRibbon />
          <ExperienceMeter />
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <LensProvider>
      <NarrativeProvider>
        <AppContent />
      </NarrativeProvider>
    </LensProvider>
  );
}

export default App;
